import { CheckRoundIcon } from "../../shared/Icons";
import { themeAtom } from "../../shared/atoms";
import { ConfirmationMessageProps } from "../models/ConfirmationMessage.model";
import { RouteParams } from "../models/VoyagePnl.model";
import { continueClickedAtomFamily, submitEnabledAtomFamily, formSubmittedAtomFamily } from "../utils/UtilFunctions";
import { useAtom, useAtomValue } from "jotai";
import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { twMerge } from "tailwind-merge";

const ConfirmationMessage: React.FC<ConfirmationMessageProps> = ({
  linkTo,
  assesmentCompleted,
  isOwnerRatingSubmitted,
  resetDrivers,
}) => {
  const theme = useAtomValue(themeAtom);
  const navigate = useNavigate();
  const { tcCode, voyageNo } = useParams<RouteParams>();
  const [, setFormSubmitted] = useAtom(formSubmittedAtomFamily({ tcCode, voyageNo }));
  const [, setContinueClicked] = useAtom(continueClickedAtomFamily({ tcCode, voyageNo }));
  const [, setSubmitEnabled] = useAtom(submitEnabledAtomFamily({ tcCode, voyageNo }));

  const title = assesmentCompleted ? "You already completed this assessment" : "Thank you for the clarifications";

  const handleNotCompletedAssesment = () => {
    resetDrivers();
    setContinueClicked(false);
    setSubmitEnabled(false);

    setTimeout(() => {
      navigate(`/voyage/assessment/${tcCode}/${voyageNo}`);
    }, 0);
  };

  const handleCompletedAssesment = () => {
    setFormSubmitted(false);

    setTimeout(() => {
      navigate(`/voyage/assessment/${tcCode}/${voyageNo}`);
    }, 0);
  };

  const handleCloseAssesment = () => {
    setTimeout(() => {
      navigate(linkTo);
    }, 0);
  };

  const handleClick = assesmentCompleted ? handleCompletedAssesment : handleNotCompletedAssesment;

  return (
    <div
      className={twMerge(
        "flex w-full flex-col items-center justify-center gap-8 rounded-xl p-20",
        theme.home.tailwind.backgound,
      )}
    >
      <div className="">
        <CheckRoundIcon className={twMerge("h-14 w-14", theme.myVesselsTableRow.status.delivered.text)} />
      </div>
      <div className={twMerge("text-[18px] font-bold", theme.uwhcAssistant.text)}>{title}</div>
      <div className="flex flex-row items-center justify-center gap-4">
        {isOwnerRatingSubmitted ? (
          <button
            type="button"
            onClick={handleCloseAssesment}
            className={twMerge(
              "flex h-[45px] w-[120px] items-center justify-center rounded border bg-[#1F8475] text-[14px]",
              theme.warningFunction.text,
              theme.uwhcAssistant.border,
            )}
          >
            Close
          </button>
        ) : (
          <>
            <button
              type="button"
              onClick={handleClick}
              className={twMerge(
                "flex h-[45px] w-[170px] items-center justify-center rounded border bg-[#1F8475] text-[14px]",
                theme.warningFunction.text,
                theme.uwhcAssistant.border,
              )}
            >
              Next to owner rating
            </button>
            <button
              type="button"
              onClick={handleCloseAssesment}
              className={twMerge(
                "flex h-[45px] w-[210px] items-center justify-center rounded border bg-[#1F8475] text-[14px]",
                theme.warningFunction.text,
                theme.uwhcAssistant.border,
              )}
            >
              Skip owner rating and close
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default ConfirmationMessage;
